$('form#comentarios').submit(function(){
	var campo = {
		"avaliacao" 		: $('input[name=avaliacao]', this),
		"nome" 				: $('input[name=nome]', this),
		"titulo_avaliacao" 	: $('input[name=titulo_avaliacao]', this),
		"mensagem" 			: $('textarea[name=mensagem]', this)
	}

	var erros = [];
	$('form#comentarios .campo-erros ul').html("");

	if( !campo.avaliacao.val() ){
		erros.push("Avaliação");
	}
	
	if( campo.nome.val().length < 5 ){
		campo.nome.addClass('is-err');
		erros.push("Nome");
	} else {
		campo.nome.removeClass("is-err");
	}

	if( campo.titulo_avaliacao.val().length < 5 ){
		campo.titulo_avaliacao.addClass('is-err');
		erros.push("Título da avaliação");
	} else {
		campo.titulo_avaliacao.removeClass("is-err");
	}

	if( campo.mensagem.val().length < 5 ){
		campo.mensagem.addClass('is-err');
		erros.push("Mensagem");
	} else {
		campo.mensagem.removeClass("is-err");
	}

	if( erros.length !== 0 )
	{
		$.each(erros, function(key, val){
			$('form#comentarios .campo-erros ul').append("<li>Verifique o campo <strong>\""+ val +"\"</strong>.</li>");
		});
		return false;
	}

});
